import { render, staticRenderFns } from "./EmailRow.vue?vue&type=template&id=352c6a1a&"
import script from "./EmailRow.ts?vue&type=script&lang=ts&"
export * from "./EmailRow.ts?vue&type=script&lang=ts&"
import style0 from "./EmailRow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports